import React, { useEffect } from 'react';

import {
  FacebookShareButton,
  WhatsappShareButton,
  TwitterShareButton,
  FacebookIcon,
  TwitterIcon,
  WhatsappIcon
} from 'react-share';

import { Container } from '@material-ui/core';

import { useCoolfoodContext } from './Store';
import { actions } from '../state/reducer';
import { i18n } from '../App';
import Button from './Button';

import { makeStyles } from '@material-ui/core/styles';

import instaLogo from '../images/instagram.png';

const useStyles = makeStyles(theme => {
  return {
    root: {},
    congratz: {
      marginTop: 20,
      textAlign: 'center',
      fontSize: 22
    },
    shareButtons: {
      display: 'flex',
      flexWrap: 'wrap',
      justifyContent: 'space-between',
      maxWidth: 300,
      margin: '10px auto'
    },
    shareButton: {
      cursor: 'pointer'
    },
    pleaseShare: {
      marginTop: 50,
      textAlign: 'center',
      fontSize: 16
    },
    goodLuck: {
      marginTop: 50,
      textAlign: 'center',
      fontSize: 22
    },
    buttonRecipes: {
      borderRadius: 0,
      marginTop: theme.spacing(4),
      boxShadow: 'none',
      backgroundColor: theme.green,
      color: '#fff',
      paddingLeft: theme.spacing(4),
      paddingRight: theme.spacing(4),
      maxWidth: 220,
      fontSize: 16
    },
    buttonProfile: {
      borderRadius: 0,
      marginTop: theme.spacing(4),
      boxShadow: 'none',
      backgroundColor: theme.pink,
      color: '#fff',
      paddingLeft: theme.spacing(4),
      paddingRight: theme.spacing(4),
      maxWidth: 220,
      fontSize: 16
    },
    buttons: {
      display: 'flex',
      flexWrap: 'wrap',
      justifyContent: 'space-around',
      margin: '10px auto'
    },
    instaButton: {

    }
  };
});

export default function Congratulation(props) {
  const [globalState, globalDispatch] = useCoolfoodContext();
  const classes = useStyles();

  useEffect(() => {
    globalDispatch({
      type: actions.SHOW_HELP,
      content: i18n._(
        'Bravo et Merci !<br>Aidez-nous à faire connaître cette démarche en partageant l\'info sur les réseaux sociaux :)<br>Vous pouvez aussi accéder à votre espace personnel et découvrir des recettes et astuces.'
      )
    });
  }, [globalDispatch]);

  const goToRecipes = () => {
    const page =
      globalState.language === 'fr'
        ? '/fr/recettes-astuces/'
        : '/en/recipes-tips/';
    window.open(page);
  };

  const goToProfile = () => {
    let page = '';
    if (window._uuid) {
      page =
        globalState.language === 'fr' ? '/fr/mon-suivi' : '/en/follow-up';
    } else {
      page =
        globalState.language === 'fr'
          ? `/fr/mon-suivi?h=${globalState.coolfooder.auth_hash}`
          : `/en/follow-up?h=${globalState.coolfooder.auth_hash}`;
    }
    window.open(`${window._siteUrl}${page}`);
  };

  const goToLoginPage = () => {
    const page =
      globalState.language === 'fr'
        ? '/fr/identification/'
        : '/en/login/';
    window.open(page);
  };

  const goToInsta = () => {
    const page =
      globalState.language === 'fr'
        ? 'https://www.instagram.com/cool_food_net/'
        : 'https://www.instagram.com/cool_food_net/';
    window.open(page);
  };

  return (
    <Container className={`congratulation ${classes.root}`}>
      <div className={classes.congratz}>
        {i18n._('Bravo et merci pour vos défis Cool Food !')}
      </div>
      <div className={classes.pleaseShare}>
        {i18n._('Souhaitez-vous partager ça avec vos amis ?')}
      </div>
      <div className={classes.shareButtons}>
        <FacebookShareButton
          quote={i18n._('Si comme moi vous souhaitez vous engager :)')}
          url={window._siteUrl}
        >
          <FacebookIcon className={classes.shareButton} round />
        </FacebookShareButton>
        <TwitterShareButton
          url={window._siteUrl}
          hashtags={['#mieux', '#manger', '#coolfood']}
        >
          <TwitterIcon className={classes.shareButton} round />
        </TwitterShareButton>
        <WhatsappShareButton url={window._siteUrl}>
          <WhatsappIcon className={classes.shareButton} round />
        </WhatsappShareButton>
        {globalState.language === 'en' &&
          <a onClick={goToInsta} className={classes.instaButton} href>
            <img width="64" height="64" src={instaLogo} alt="helper" />
          </a>
        }
      </div>
      <div className={classes.goodLuck}>
        {i18n._('Nous vous souhaitons bonne chance dans leur réalisation :)')}
      </div>
      <div className={classes.buttons}>
        <Button onClick={goToRecipes} className={classes.buttonRecipes}>
          {i18n._('Découvrez les recettes et astuces')}
        </Button>
        {(!globalState.coolfooder.exists || (globalState.coolfooder.exists && window._uuid)) && (
          <Button onClick={goToProfile} className={classes.buttonProfile}>
            {i18n._('Visitez votre espace personnel')}
          </Button>
        )}
        {(globalState.coolfooder.exists && !window._uuid) && (
          <Button onClick={goToLoginPage} className={classes.buttonProfile}>
            {i18n._('Je me connecte à mon espace personnel')}
          </Button>
        )}
      </div>
    </Container>
  );
}
